<template>
  <div id="viewer">
    <div class="sdiv fl two prelative cpointer mb30 ml5 mr30 ofhidden" v-for="(item,index) in list" :key="item.id">
      <img class="hbig" :src="item['picture'][0]" width="280" height="200" />
      <div class="txt pabsolute twhite fs16 pl15">{{item.title}}</div>
    </div>
  </div>
</template>

<script>
import Viewer from "../../../static/viewer/viewer.min.js";
import Start from '../../../static/viewer/start.js'
export default {
  name: "NevItem",
  props:[
    'list'
  ],
  mounted() {
    this.$nextTick(function(){
      var viewer = new Viewer(document.getElementById('viewer'), {
        url: 'src'
      });
      Start.start();
    })
  },
  updated() {
    this.$nextTick(function(){
      var viewer = new Viewer(document.getElementById('viewer'), {
        url: 'src'
      });
      Start.start();
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/NevItem.vue